function apiBaseUrl() {
  return process.env.REACT_APP_IE_API_BASE_URL;
}

export function opportunities(page) {
  return `${apiBaseUrl()}/project-finder`
}

export function projectAlertsPost() {
  return `${apiBaseUrl()}/project_finder/alerts`
}



// WEBPACK FOOTER //
// ./src/features/projectFinder/apiUrls.js